var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show && _vm.icon)?_c('li',[_c('a',_vm._b({staticClass:"button link no-bg help__action",class:{ 'with-black-caret': _vm.hasCaret },attrs:{"href":_vm.href,"target":"_blank"}},'a',_vm.$attrs,false),[_c('IconRegistry',{staticClass:"help__action__icon",attrs:{"name":_vm.icon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }